import { FormContainer, FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  OrganizationalAndLegalFormFormType,
  FormErrors,
  getSchema,
} from '../../forms/organizationalAndLegalFormForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps, FormContainerStepProps {
  initialValues?: OrganizationalAndLegalFormFormType;
  canGoBack?: boolean;
  formError?: FormErrors;
  submitLoading?: boolean;
  onSubmit: (values: OrganizationalAndLegalFormFormType) => void;
  onGoBack?: () => void;
}

export const OrganizationalAndLegalForm = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  step,
  ...formProps
}: Props) => {
  const schema = getSchema(formProps.enabledOrganizationType);
  const { t } = useTranslation();
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.organizationalAndLegalForm.subtitle')}
      title={t('onboarding.organizationalAndLegalForm.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormContainer>
  );
};
